import { Hospital } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Демо-клиника для продаж (БО-05; DODOC_ADMIN, DODOC_SUPPORT): состояние, сброс сейчас, ночной сброс (флаг — DODOC_ADMIN). */
export const section = defineSection({
  id: 'backoffice.demo',
  area: 'backoffice',
  path: 'demo',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: Hospital,
  titleKey: 'boDemo:title',
  namespaces: ['boClinics', 'portal', 'backoffice'],
  navGroup: 'clients',
  order: 40,
  load: () => import('./DemoPage'),
});
